import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Sustainable">
                            <h2>Managed Mobility Solutions To Help Your Business!</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>How we communicate, build, travel, and do business is different from what it used to be. This situation demands technology services that provide actual value. TekRevol’s managed mobility solutions help us manage everything for you.</p>
                        <p>Our mobility services providers comprehensively cover all the aspects of your operations, eventually improving the processes and providing infrastructural support that enables smooth execution and implementation. We manage millions of devices worldwide, helping our clients track and manage them conveniently.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;